import {useEffect} from "react"

/*
  useDebounce: Only returns the latest value when the useDebounce hook has not been called for the specified time period
  https://usehooks.com/useDebounce/
*/
export const useDebounce = (value, delay, fn) => {
  useEffect(() => {
    const handler = setTimeout(fn, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [JSON.stringify(value), delay])
}



// WEBPACK FOOTER //
// ./src/hooks/useDebounce.js